export default {"src":"/_next/static/image/public/images/svgs/arrow-curved-down-left.505fd23b5ae6fe83319e02a7e9eb0d4e.svg","height":72,"width":41};